import { HackneyGraphId } from '../../../../../../types/alice-bob';
import Button from './button/Button';
import Place from './place/Place';
import Player from './player/Player';

const WIDTH = 617;
const HEIGHT = 120;

export default class Entry extends Phaser.GameObjects.Container {
    private config: { place: number } & HackneyGraphId;
    private bg!: Phaser.GameObjects.Image;
    private place!: Place;
    private player!: Player;
    private button!: Button;

    constructor(scene: Phaser.Scene, x: number, y: number, config: { place: number, claimed: boolean } & HackneyGraphId) {
        super(scene, x, y);

        this.config = config;

        this.setupBG();
        // this.setupPlace();
        this.setupPlayer();
        if (!config.claimed) this.setupButton();
    }

    static get WIDTH() {
        return WIDTH;
    }

    static get HEIGHT() {
        return HEIGHT;
    }

    setupBG() {
        let frame = 'gui/common/user_entry_bg';

        this.bg = this.scene.add.image(0, 0, 'atlas', frame);
        this.add(this.bg);
    }

    // setupPlace() {
    //     let x = -250;
    //     let y = 0;

    //     this.place = new Place(this.scene, x, y, this.config.place);
    //     this.add(this.place);
    // }

    setupPlayer() {
        let x = -250;
        let y = -9;

        this.player = new Player(this.scene, x, y, this.config);
        this.add(this.player);
    }

    setupButton() {
        let x = 200;
        let y = 0;

        this.button = new Button(this.scene, x, y, this.config.id);
        this.add(this.button);
    }
}
